import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';
import color from '../../../config/colors.json';

export const Container = styled.div`
	margin: 32px 0 20px;
`;

export const Title = styled.h1`
	color: ${color.lightGreyMidias};
`;

export const LinksContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 20px;
`;

export const CampaignBox = styled.div`
	background-color: ${color.light};
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	width: calc(calc(100% / 3) - calc(48px / 2));
	padding: 18px 20px 35px;
	justify-content: center;
	align-items: center;
	box-shadow: 0 2px 2px ${color.darkGrey3_15};
	> span {
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
		width: 100%;
	}
	> [role^='img'] {
		max-width: 116px;
		max-height: 116px;
		margin: 79px 0 11px;
	}
	> em {
		font-family: 'Poppins', sans-serif;
		font-size: 40px;
		line-height: 56px;
		font-weight: 500;
		font-style: normal;
		margin-bottom: 55px;
	}
	> div {
		width: 100%;
		padding: 0 12px;
	}
	@media screen and (max-width: ${ScreenSize.laptop}px) {
		> [role^='img'] {
			margin: 34px 0 11px;
		}
		> em {
			margin-bottom: 15px;
			font-size: 20px;
		}
	}
`;


export const BoxRecurrency = styled.div`
   background-color: #fff;
   padding: 0 50px;
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        background-color: #fff;
        margin-top: 30px;
        padding: 0 30px;
    }
`;

export const BoxPontual = styled.div`
   margin-top: 34px;
   padding: 0 23px 77px;
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        padding: 0 23px 18px;
        margin-top: 0;
    }
`;
    export const StyledBox = styled.div`
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        margin-bottom: 30px;
    }
`;
